/**
 * Merge a comparison-model performance payload into the primary payload.
 *
 * The backend returns one payload per (base_model_name, filters) combination
 * with each StatRow shaped as `{key, metric, current, comparison: null, unit}`.
 * When the user picks a Compare: version, we fetch a second payload for the
 * comparison base model and copy its `current` values into the primary
 * payload's `comparison` column so a single table can render both.
 */

function mergeStatRows(primaryRows, comparisonRows) {
  if (!Array.isArray(primaryRows)) return primaryRows || null;
  if (!Array.isArray(comparisonRows)) {
    return primaryRows.map((row) => ({ ...row, comparison: null }));
  }
  const byKey = new Map(comparisonRows.map((row) => [row.key, row]));
  return primaryRows.map((row) => ({
    ...row,
    comparison: byKey.get(row.key)?.current ?? null,
  }));
}

/**
 * @param {Object|null} primary    Primary (current model) performance payload.
 * @param {Object|null} comparison Comparison-model payload, or null when none.
 * @returns {Object|null}          A new payload with merged `comparison` values,
 *                                 or the primary payload as-is when no merge is possible.
 */
export function mergeComparisonIntoMetrics(primary, comparison) {
  if (!primary) return null;
  if (!comparison) return primary;
  return {
    ...primary,
    inferenceLatency: mergeStatRows(primary.inferenceLatency, comparison.inferenceLatency),
  };
}
